import React from 'react';
import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';
import { useEffectiveReportTheme } from '../../../../lib/useEffectiveReportTheme';
import { EditorialBadge, EditorialDataTable, type EditorialBadgeTone } from '../../report/editorial';

/** Advantage → EditorialBadge tone (replaces filled pill backgrounds). */
function advantageTone(advantage: string): EditorialBadgeTone {
  if (advantage === 'BTM') return 'positive';
  if (advantage === 'Grid') return 'accent';
  return 'neutral';
}

export const GridVsBtmSection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const theme = useEffectiveReportTheme();
  const rows = report.gridVsBtmComparison ?? [];
  return (
    <SectionShell label={label} hasData={rows.length > 0}>
      {/* data-span-columns: defensive — lets the wide table span both flow
          columns if this section's supportsColumnLayout is ever flipped on.
          Carrier div holds the testid (EditorialDataTable has no testid prop). */}
      <div data-span-columns className="overflow-x-auto" data-testid="grid-vs-btm-table">
        <EditorialDataTable
          theme={theme}
          columns={[
            { header: 'Metric' },
            { header: 'Grid' },
            { header: 'BTM' },
            { header: 'Advantage' },
          ]}
          rows={rows.map(row => [
            row.metric,
            row.gridOption,
            row.btmOption,
            <EditorialBadge
              theme={theme}
              tone={advantageTone(row.advantage)}
              variant="outline"
              style={{ whiteSpace: 'normal' }}
            >
              {row.advantage}
            </EditorialBadge>,
          ])}
        />
      </div>
    </SectionShell>
  );
};
